import fetch from 'isomorphic-fetch';
import {
	API2_URL,
	LINES_REQUEST,
	LINES_SHOW,
	LINES_EDIT,
	LINES_CLEAR,
	LINES_COMPLETE,
	LINES_FAIL
} from "../store/config";
import { newNotification } from "./notifications";
import _ from "lodash";
import {sessionService} from "redux-react-session";
import {history} from "../store/store";
import {statusGroupList} from "./status";

export const linesShow = (page=1, filters={}) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};

				let params = '';
				_.mapKeys(filters, (value, key) => {
					if(value){
						params = `${params}&${key}=${value}`;
					}
				});

				dispatch(linesRequest());
				return fetch(`${API2_URL}/proigualdad/lines?page=${page}${params}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(linesData(json)),
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(linesFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
};

export const linesList = (status_id=undefined) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};

				dispatch(linesRequest());
				return fetch(`${API2_URL}/proigualdad/lines?per_page=all${ !isNaN(status_id) ? '&status_id='+status_id : ''}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(linesData(json)),
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(linesFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
};

export const fetchLineComplete = (id = undefined) => (dispatch) => {
	dispatch(linesRequest());
	dispatch(linesClear());

	return dispatch(statusGroupList())
		.then((status) => {
			if(!_.isEmpty(status.payload)){
				if(id){
					return dispatch(lineEdit(id))
				} else {
					return dispatch(linesComplete());
				}
			}else {
				return dispatch(linesFail('Carga incompleta'))
			}
		});
}

export const lineEdit = (id = undefined) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			const options = {
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'get'
			};

			dispatch(linesRequest());
			dispatch(linesClear());

			return fetch(`${API2_URL}/proigualdad/lines/${id}`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => dispatch(linesEditData(json)),
					error => {
						dispatch(newNotification({title: "¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
						return dispatch(linesFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				);
		})
}

export const lineEditSave = (values) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			const options = {
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'post',
				body: JSON.stringify(values)
			};

			dispatch(linesRequest());
			return fetch(`${API2_URL}/proigualdad/lines${values.id ? `/${values.id}?_method=PUT`:''}`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => {
						dispatch(newNotification({title: "Éxito", content: json.message ? json.message:"La linea se ha guardado correctamente", type: "success"}));
						if(_.isEmpty(values.id)){
							history.push(`/proigualdad/lineas/editar/${json.data.id}`);
						}
						return dispatch(linesEditData(json))
					},
					error => {
						dispatch(newNotification({title: "¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
						return dispatch(linesFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				)
		})
}

export const lineDelete = (id) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			const options = {
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'delete'
			};

			dispatch(linesRequest());
			return fetch(`${API2_URL}/proigualdad/lines/${id}`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => {
						dispatch(newNotification({title: "Éxito", content: json.message ? json.message:"La linea se ha borrado correctamente", type: "success"}));
						dispatch(linesShow())
					},
					error => {
						dispatch(newNotification({title: "¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
						return dispatch(linesFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				)
		})
}

const linesData = (json) => {
	let lines =_.orderBy(json.data,['code'],['asc']);
	return {
		type: LINES_SHOW,
		isFetching: false,
		payload: lines,
		pages: {
			current: json.current_page,
			per_page: json.per_page,
			total: json.total
		},
		permissions: json.permissions,
		timestamp: Date.now()
	}
};

const linesEditData = (json) => {
	return {
		type: LINES_EDIT,
		isFetching: false,
		payload: json.data,
		permissions: json.permissions,
		timestamp: Date.now()
	}
};

const linesRequest = () => {
	return {
		type: LINES_REQUEST,
		isFetching: true,
		timestamp: Date.now()
	}
};

const linesClear = () => {
	return {
		type: LINES_CLEAR,
		payload: {},
		timestamp: Date.now()
	}
};

const linesComplete = () => {
	return {
		type: LINES_COMPLETE,
		isFetching: false,
		timestamp: Date.now()
	}
}

const linesFail = (error) => {
	return {
		type: LINES_FAIL,
		isFetching: false,
		error: error,
		timestamp: Date.now()
	}
};


// WEBPACK FOOTER //
// ./src/actions/lines.js